/**
 * The tray's fraction, shared by every run type (DD-031).
 *
 * A zero denominator means there is nothing to count (a genuine empty run, or a
 * run whose total is not known yet). Render no fraction at all: an em dash reads
 * as missing data and `0/0` reads as broken.
 */
export interface RunMetric {
  done: number;
  total: number;
}

export function formatRunMetric(metric: RunMetric): string {
  if (metric.total <= 0) {
    return '';
  }
  return `${metric.done}/${metric.total}`;
}
